import http, { httpWithoutHeaders } from '../api';
export const getCredits = async (page) =>
  await http.get(`/enduser/credit/all/?page=${page}&limit=5`);
export const getCreditsByMerchantId = async (merchantId,page) =>
  await http.get(`/enduser/credit/merchant-detail/?merchant_id=${merchantId}&page=${page}&limit=3`);
